export { default } from './PdfComponent';
